const de = {
  title: 'Home',
  editMode: 'Bearbeitungsmodus',
  systemTilesTitle: 'System Kacheln',
  customTilesTitle: 'Individuelle Kacheln',
  notSaveMessage: 'Beim Verlassen der Seite gehen nicht gespeicherte Änderungen verloren!',
  viewAll: 'Alle ansehen',
  cardDrawer: {
    drawerTitle: 'Neue Kachel anlegen',
    predefinedDrawerTitle: 'Neue Kacheln hinzufügen',
    defaultIconDrawerTitle: 'Wähle ein vordefiniertes Icon für deine Kachel',
    drawerCreateSystemTitle: 'Neue System-Kachel anlegen',
    drawerEditSystemTitle: 'System-Kachel bearbeiten',
    title: 'Titel',
    titleEN: 'Titel (Englisch)',
    link: 'Link',
    styleType: 'Spezielles Styling',
    moreOptions: 'Mehr Optionen',
    lessOptions: 'Weniger Optionen',
    shortText: 'Kurzbeschreibung',
    shortTextEN: 'Kurzbeschreibung (Englisch)',
    tileIcon: 'Kachel-Icon',
    external: 'Ist der Link eine externe Seite?',
    notInNavInfo:
      'Die Kachel erscheint nicht in der Navigationsleiste sondern ist lediglich auf dem Dashboard.',
    roundImage: 'Soll das Bild abgerundet werden?',
    visibilityGroups: 'Nutzergruppen',
    createOwnTile: 'Eigene Kachel anlegen',
    info: 'Wähle eine vordefinierte Kachel aus oder lege selbst eine an.',
    defaultIcons: 'Icon wählen',
    noDefaultTiles:
      'Es gibt noch keine vordefinierten Kacheln. Legen Sie stattdessen eine eigene Kachel an.',
    noDefaultIcons: 'Es gibt noch keine vordefinierten Icons.',
    systemTile: 'System-Kachel',
    defaultTile: 'Vordefinierte-Kachel',
    tooltips: {
      systemTile:
        'System Kacheln können von den Benutzer nicht entfernt werden und sind somit fest für die gewählten Nutzergruppen.',
      defaultTile:
        'Vordefinierte Kacheln können von Benutzern bei Bedarf ausgewählt und zum eigenen Dashboard hinzugefügt werden.',
      externalLinkTip: 'Öffnet Link in neuem Tab.'
    },
    placeholder: {
      title: 'Kachelbezeichnung',
      description: 'Kachelbeschreibung',
      uploadImage: 'Icon hochladen'
    }
  },
  alerts: {
    successfulCreate: 'Die Kachel wurde angelegt.',
    successfulUpdate: 'Die Kachel wurde bearbeitet.',
    successfulRemove: 'Die Kachel wurde entfernt.',
    failedCreate: 'Die Kachel konnte nicht angelegt werden.',
    failedUpdate: 'Die Kachel konnte nicht bearbeitet werden.',
    failedRemove: 'Die Kachel konnte nicht entfernt werden.',
    failedUpload: 'Das Icon konnte nicht hochgeladen werden.'
  },
  dialog: {
    deleteConfirm: {
      title: 'Wirklich entfernen?',
      message:
        'Wenn es sich um eine vordefinierte Kachel handelt, kann dieser jederzeit wieder hinzugefügt werden.\n Wenn es allerdings eine selbstangelegte Kachel ist, wird diese gelöscht.'
    },
    cancelEditMode: {
      title: 'Wirklich schließen?',
      message: 'Durch Bestätigung wird jede Änderung zurückgesetzt'
    }
  },
  jobmarket: 'Stellenmarkt',
  timeTable: {
    title: 'Stundenplan',
    description: 'Hier finden Sie alle Lehrveranstaltungen'
  },
  onlineServiceCenter: {
    title: 'Online-Service-Center',
    description: 'Prüfungsanmeldung und Noteneinsicht'
  },
  safetyAndHealth: {
    title: 'Arbeitssicherheit und Gesundheitsschutz',
    description: 'Arbeits- und Gesundheitsschutz an der TH Rosenheim'
  },
  documentResearch: {
    title: 'Dokumentenrecherche',
    description: 'DMS-System der TH Rosenheim'
  },
  primion: {
    title: 'Primion',
    description: 'Portal für Arbeitszeitmanagement (VPN notwendig)'
  },
  employeePortal: {
    title: 'Mitarbeiterportal',
    description: 'Dienstreisen, Gehaltsnachweise etc.'
  },
  incomings: {
    description: 'Belegungstool für Gaststudenten'
  },
  learningCampus: {
    title: 'Learning Campus',
    description: 'Die Lernplattform unserer Hochschule'
  },
  openCast: {
    title: 'OpenCast Videos',
    description: 'Video Plattform der TH Rosenheim'
  },
  acquisition: {
    title: 'Beschaffung',
    description: 'Interne Hochschulbeschaffung'
  },
  announcements: {
    title: 'Beiträge',
    description: 'Die neuesten Beiträge in Deiner Community'
  },
  bulletin: {
    title: 'Schwarzes Brett',
    description: 'Schau dir an, was angeboten wird'
  },
  company: {
    description: 'Bearbeiten der Firmendaten & Verwalten der Stellenanzeigen',
    maintenance:
      'Der Stellenmarkt ist wegen Wartungarbeiten bis Mittwoch den 12.07.2023 geschlossen',
    maintenanceTitle: 'Wartungsarbeiten'
  },
  ioCourses: {
    title: 'Kurse',
    description: 'Kursregistrierung für Austauschstudierende / International Office'
  },
  ioEvents: {
    title: 'Events',
    description: 'Eventregistrierung für internationale Studierende / International Office'
  },
  ioUsers: {
    title: 'Nutzer',
    description: 'Hier finden Sie alle Nutzer vom International Office'
  },
  articlesList: {
    heading: 'Veranstaltungen und Ankündigungen',
    today: 'Heute',
    further: 'Weitere Veranstaltungen und Ankündigungen'
  },
  phoneList: {
    title: 'Telefonliste',
    description: 'Finde alle Kontakte hier'
  },
  calendar: {
    heading: 'Kalender',
    event: 'Veranstaltung',
    general: 'Allgemein',
    study: 'Studium',
    legal: 'Rechtliches',
    holiday: 'Ferien',
    action: 'Zum Kalender'
  },
  watchlist: {
    heading: 'Merkliste',
    action: 'Alle ansehen',
    alreadyAdded: 'Bereits in der Merkliste',
    empty: 'Noch nichts in der Merkliste',
    deleteError: 'Entfernen aus der Merkliste fehlgeschlagen',
    deleteSuccess: 'Erfolgreich aus der Merkliste entfernt',
    addSuccess: 'Erfolgreich in die Merkliste eingetragen',
    addError: 'Fehler beim hinzufügen in die Merkliste'
  },
  notifications: {
    heading: 'Benachrichtigungen'
  },
  syncShare: {
    title: 'Sync + Share',
    description: 'Hier gelangen Sie zum Sync + Share der TH Rosenheim'
  },
  library: {
    title: 'OPAC',
    descriptionPart1: 'Bibliothekskatalog',
    descriptionPart2: 'E-Books nutzbar via VPN-Client'
  },
  activityLog: {
    title: 'Aktivitäts Log',
    description: 'Hier finden Sie alle kürzlichen Aktivitäten'
  },
  events: {
    title: 'Veranstaltungen',
    description: 'Hier finden Sie alle Veranstaltungen'
  },
  fundings: {
    title: 'Förderinfos',
    description: 'Hier erhalten Sie Informationen über aktuelle Förderprogramme'
  },
  leihBar: {
    title: 'leihBar',
    description: 'buchen, teilen, leihen von Medientechnik bis Spezialräume'
  },
  formsIntern: {
    title: 'Portal für Freistellungssemester',
    description: 'Anträge auf Freistellungen (z.B. Forschungssemester) stellen'
  },
  vhb: {
    title: 'VHB-Kurse',
    description: 'Registrierung für VHB-Kurse',
    dialog: {
      title: 'Registrierung für VHB-Kurse',
      confirmButton: 'Gehe zu vhb.org',
      information: `Registrieren Sie sich bei der vhb unter www.vhb.org mit Ihrer Studierenden-E-Mail-Adresse (max.mustermann@stud.th-rosenheim.de) oder melden sich dort zurück, falls Sie schon einen Kurs besucht haben.

        Melden Sie sich dann unter www.vhb.org für Ihren entsprechenden Kurs an. 
        Die Kursanmeldungen sind meist ab dem 15.03. oder 01.10. möglich.
       
        Weitere Informationen zu Anrechnungen in den jeweilige Fakultäten an der TH Rosenheim: `
    }
  }
};

export default de;
export type HomeTranslation = typeof de;
